import {Component, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {GridOptions, ColDef, ColGroupDef, GridApi} from 'ag-grid-community';
import {XTOSReportingService} from 'src/app/services/XTOS-reporting/xtos-reporting.service';
import {BehaviorSubject, Observable, of} from 'rxjs';
import {
  HHGIffShipmentDetailResponse,
  XTOSShipmentSummaryResponse
} from 'src/app/shared/common-components/common-structure';
import { AsyncPipe } from '@angular/common';
import {AgGridAngular} from "ag-grid-angular";
import {XtosShipmentComponent} from "./xtos-shipment/xtos-shipment.component";
import {BsModalRef, BsModalService} from "ngx-bootstrap/modal";
import {IffShipmentSummaryService} from "../../services/iff-shipment-summary/iff-shipment-summary.service";
import {AlertService} from "../../services/alert/alert.service";
import {LoadingService} from "../../services/loading/loading.service";
import {Router} from "@angular/router";
import {
  ConfirmationModalComponent
} from "../../shared/common-components/confirmation-modal/confirmation-modal.component";
import {catchError, startWith, switchMap, takeWhile} from "rxjs/operators";
import { CustomHeader } from "./../iff-shipment/iff-shipment-summary/iff-shipment-summary-custom-header.component";
@Component({
    selector: 'app-xtos-reporting',
    templateUrl: './xtos-reporting.component.html',
    styleUrls: ['./xtos-reporting.component.css'],
    imports: [
    AgGridAngular,
    AsyncPipe
]
})
export class XtosReportingComponent implements OnInit, OnDestroy {
  title: string = 'XTOS Shipment Reports Master List';
  private observer$ = new BehaviorSubject(true);
  private isNoRowSelectedEvent$ = new BehaviorSubject(true);
  isNoRowSelected$ = this.isNoRowSelectedEvent$.asObservable();
  gridOptions: GridOptions;
  detailGridOptions: GridOptions;
  gridOptionsApi: GridApi;
  modalRef: BsModalRef;
  frameworkComponents: any;
  iffMasterId: number;
  endRoute: String;
  private gridApi!: GridApi<any>;

  XTOSShipmentPaginationResults$: Observable<XTOSShipmentSummaryResponse[]> = this.xtosReportingService.getXTOSReportingMasterSummary();
  detailGridColumnDefs: (ColDef | ColGroupDef)[] = [
      <ColDef>
        {
          headerName: 'SCAC Code',
          field: 'scac',
        },
      {
        headerName: 'SCAC ',
        field: 'scacName'
      },
      {
        headerName: 'FAIC ',
        field: 'faicCode'
      },
      {
        headerName: 'Agency Bureau Name',
        field: 'agencyBureauName'
      },
      {
        headerName: 'Pro Bill Number',
        field: 'proBillNumber'
      },
      {
        headerName: 'BOL',
        field: 'bolNumber'
      },
      {
        headerName: 'Move Type',
        field: 'moveType'
      },
      {
        headerName: 'Pickup Date',
        field: 'pickupDate'
      },
      {
        headerName: 'Date into Extended Storage',
        field: 'deliveryDate'
      },
      {
        headerName: 'Storage Location',
        field: 'storageLoc'
      },
      {
        headerName: 'Storage Zip',
        field: 'storageZip'
      },
      {
        headerName: 'Storage Address',
        field: 'storageAddr'
      },
      {
        headerName: 'Last Name',
        field: 'employeeLastName'
      },
      {
        headerName: 'Weight',
        field: 'weight',
        sortable: true,
        comparator: this.iffShipmentSummaryService.numberComparator
      },
      {
        headerName: 'Total Amount Invoiced',
        field: 'grossAmount',
        valueFormatter: this.iffShipmentSummaryService.formatNumber,
        comparator: this.iffShipmentSummaryService.numberComparator
      },
      {
        headerName: 'Pass Thr amt',
        field: 'passThruAmount',
        sortable: true,
        valueFormatter: this.iffShipmentSummaryService.formatNumber,
        comparator: this.iffShipmentSummaryService.numberComparator
      },
      {
        headerComponent: CustomHeader,
        field: 'totalIFF',
        valueFormatter: this.iffShipmentSummaryService.formatNumber,
        filter: 'agTextColumnFilter',
        sortable: true,
        comparator: (valueA, valueB) => {
          const parseCurrency = (val: any): number => {
            if (val === null || val === undefined) return 0;
            if (typeof val === 'number') return val;
            const cleanStr = String(val).replace(/[^0-9.-]/g, '');
            const num = parseFloat(cleanStr);
            return isNaN(num) ? 0 : num;
          };
          return parseCurrency(valueA) - parseCurrency(valueB);
        }
      }
    ];
  XtosShipmentSummaryColumnDefs: (ColDef | ColGroupDef)[] = [
    <ColDef>{
      checkboxSelection: true,
      width: 80
    },
    {
      headerName: 'SCAC Code',
      field: 'scac',
      filter: 'agTextColumnFilter',
      sortable: true,
      cellRenderer: 'agGroupCellRenderer', chartDataType: 'category'
      // onCellClicked: event => this.onSCACClicked(event.data)
    },
    {
      headerName: 'TSP Name',
      field: 'scacName',
      filter: 'agTextColumnFilter',
      sortable: true, chartDataType: 'series'
    },
    {
      headerName: 'Reporting Year',
      field: 'reportingYear',
      filter: 'agTextColumnFilter',
      sortable: true, chartDataType: 'series'
    },
    {
      headerName: 'Reporting Quarter',
      field: 'reportingQuarter',
      filter: 'agTextColumnFilter',
      sortable: true, chartDataType: 'series'
    },
    {
      headerName: 'Status',
      field: 'status',
      filter: 'agTextColumnFilter',
      sortable: true,
      chartDataType: 'series'
    },
    {
      headerName: 'Move Type',
      field: 'moveType',
      filter: 'agTextColumnFilter',
      sortable: true
    },
    {
      headerName: 'Storage Type',
      field: 'storageType',
      filter: 'agTextColumnFilter',
      sortable: true
    },
    {
      headerName: 'Processing Date & Time',
      field: 'receivedDate',
      filter: 'agTextColumnFilter',
      sortable: true
    },
    {
      headerName: 'Number of Shipments',
      field: 'numberOfShipments',
      filter: 'agTextColumnFilter',
      sortable: true,
      comparator: this.iffShipmentSummaryService.numberComparator
    },
    {
      headerName: 'Net Amount',
      field: 'netAmount',
      filter: 'agTextColumnFilter',
      sortable: true,
      valueFormatter: this.iffShipmentSummaryService.formatNumber,
      comparator: this.iffShipmentSummaryService.currencyComparator
    },
    {
      headerName: 'Pass-Through Amount',
      field: 'passThruAmount',
      filter: 'agTextColumnFilter',
      sortable: true,
      valueFormatter: this.iffShipmentSummaryService.formatNumber,
      comparator: this.iffShipmentSummaryService.currencyComparator
    },
    {
      headerComponent: CustomHeader,
      field: 'totalIFF',
      filter: 'agTextColumnFilter',
      sortable: true,
      valueFormatter: this.iffShipmentSummaryService.formatNumber,
      comparator: this.iffShipmentSummaryService.currencyComparator
    }
  ];

  constructor(private iffShipmentSummaryService: IffShipmentSummaryService,
              private xtosReportingService: XTOSReportingService,
              private alertService: AlertService, private loader: LoadingService,
              private modalService: BsModalService,
              private router: Router) {
  }

  ngOnInit() {
    this.endRoute = this.router.url.substring(1);
    this.detailGridOptions = <GridOptions>{
      columnDefs: this.detailGridColumnDefs,
      rowSelection: 'multiple',
      defaultColDef: {
        sortable: true,
        resizable: true,
        filter: 'agTextColumnFilter',
        filterParams: {
          suppressAndOrCondition: false
        }
      },
      headerHeight: 50,
      pagination: true,
      paginationPageSize: 10,
      cacheBlockSize: 10,
      suppressDragLeaveHidesColumns: true,
      onGridReady: params => {
        // this.IFFShipmentDetailResults$.subscribe(results => params.api.setRowData(results));
        //params.api.sizeColumnsToFit();
        this.gridApi = params.api;
      },
      overlayLoadingTemplate:
        '<span class="ag-overlay-loading-center">Please wait while your rows are loading</span>',
      overlayNoRowsTemplate:
        '<span>No results found. Please adjust your filters.</span>'
    };
    this.gridOptions = <GridOptions>{
      columnDefs: this.XtosShipmentSummaryColumnDefs,
      defaultColDef: {
        sortable: true,
        resizable: true,
        filter: 'agTextColumnFilter',
        filterParams: {
          suppressAndOrCondition: false
        }
      },
      masterDetail: true,
      headerHeight: 50,
      pagination: true,
      paginationPageSize: 25,
      cacheBlockSize: 25,
      rowSelection: 'multiple',
      rowMultiSelectWithClick: true,
      suppressDragLeaveHidesColumns: true,
      detailCellRendererParams: {
        detailGridOptions: this.detailGridOptions,
        getDetailRowData: params => {
          this.loader.show();
          console.log(params.data);
          this.xtosReportingService.getXTOSReportingMasterDetailSummary(params.data.xtosMasterId)
            .pipe(takeWhile(() => this.observer$.value))
            .subscribe(results => {
              params.successCallback(results);
              this.loader.hide();
            }, error => this.loader.hide())
        }
      },
      isRowMaster: rowData => rowData ? rowData.numberOfShipments > 0 : false,
      onGridReady: params => {
        this.gridOptionsApi = params.api;
        params.api.sizeColumnsToFit();
      },
      onSelectionChanged: params => {
        const selectedRows = params.api.getSelectedNodes();
        if (selectedRows && selectedRows.length > 0) {
          this.isNoRowSelectedEvent$.next(false);
        } else {
          this.isNoRowSelectedEvent$.next(true);
        }
      },
      defaultExportParams: {
        getCustomContentBelowRow: params => {
          return [];
        }
      },
      overlayLoadingTemplate:
        '<span class="ag-overlay-loading-center">Please wait while your rows are loading</span>',
      overlayNoRowsTemplate:
        '<span>No results found. Please adjust your filters.</span>'
    };

  }

  onDelete() {
    this.modalRef = this.modalService.show(ConfirmationModalComponent);
    this.modalRef.content.question = 'Are you Sure, Do You Want to Delete this Shipment Report Record(s)?';
    this.modalRef.content.title = 'Deleting Shipment Reports';
    this.modalRef.content.confirmText = 'Yes';
    this.modalRef.content.cancelText = 'No';
    this.modalRef.content.emitData.subscribe(result => {
      if (result.obj === true) {
        this.loader.show();
        const selectedRows = this.gridOptionsApi.getSelectedRows();
        this.xtosReportingService.deleteXtosShipment(selectedRows.map(xtos => +xtos.xtosMasterId))
          .subscribe(() => {
            this.loader.hide();
            this.alertService.success('Successfully Deleted Shipment Report Record');
            this.gridOptionsApi.applyTransaction({ remove: selectedRows });
          }, err => {
            this.loader.hide();
            this.alertService.error('There was an error deleting Shipment Report');
          });
      }
    });
  }

  onDelinquencyReportClicked() {
    this.router.navigate(['/', 'xtosDelinquencyReport']);
    // this.delinquencyReportSelected.emit(); TODO
  }

  onComprehensiveReportClicked() {
    this.router.navigate(['/', 'xtosComprehensiveReport']);
    // this.comprehensiveReportSelected.emit(); TODO
  }

  ngOnDestroy() {
    this.observer$.next(false);
  }

}
